import React from "react";

export default function useIsInViewport(
    ref: React.MutableRefObject<Element | null>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    visibleItems: any[],
    containerRef?: React.MutableRefObject<Element | null>
): boolean {
    const [isIntersecting, setIsIntersecting] = React.useState(false);

    const observer = React.useMemo(
        () =>
            new IntersectionObserver(
                ([entry]) => {
                    setIsIntersecting(entry.isIntersecting);
                },

                {
                    root: containerRef?.current || null,
                    rootMargin: "0px",
                    threshold: 0.9,
                }
            ),

        []
    );

    React.useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [ref, visibleItems, observer]);

    return isIntersecting;
}
